module.exports = __webpack_public_path__ + "static/media/paynow-logo.bfb501f1.png";